import React from "react";
import { Question } from "../../@types/question.interface";
import "./answer-sheet.styles.scss";
import { Answer } from "../../@types/answer.interface";

interface IProps {
    questions: Question[];
    answers: Answer[];
    handleClick: (evt: any, name: string, idx?: number) => void;
}

export default function AnswerSheet({
    questions,
    answers,
    handleClick,
}: IProps) {
    return (
        <div className="board">
            <div className={`board__answer-sheet`}>
                <div className="board__answer-sheet__title">
                    <span>Question No.</span>
                </div>
                <div className="board__answer-sheet__detail">
                    {questions.map((question, index) => (
                        <div
                            key={index}
                            className="cursor"
                            onClick={(evt) => handleClick(evt, "change", index)}
                        >
                            <div
                                className={`board__answer-sheet__detail__index ${
                                    answers[index].student_answer[0].answer !==
                                    "-"
                                        ? "checked-answer"
                                        : "empty-answer"
                                }`}
                            >
                                {index + 1}.
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
